import { MenuItem } from "@/models/menuItem";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import PartnerPortalDashboardIcon from "../../../../public/icons/partner-portal-dashoard.svg";
import PartnerPortalDocIcon from "../../../../public/icons/partner-portal-documents.svg";

type PartnerPortalSidebarProps = {
  show: boolean;
  setter: any;
};

const partnerPortalMenu: MenuItem[] = [
  {
    name: "Dashboard",
    IconComponent: PartnerPortalDashboardIcon,
    href: "/partner-portal/dashboard",
  },
  {
    name: "Documents",
    IconComponent: PartnerPortalDashboardIcon,
    href: "/partner-portal/documents",
  },
  {
    name: "Shared Forms",
    IconComponent: PartnerPortalDashboardIcon,
    href: "/partner-portal/shared-forms",
  },
];

export default function PartnerPortalSidebar({
  show,
  setter,
}: PartnerPortalSidebarProps) {
  const router = useRouter();
  const pathname = usePathname();

  return (
    <>
      <div className="h-screen pt-7 pl-[1.875rem] flex flex-col bg-white bg-opacity-30 text-custom-gray">
        <div>
          <Image
            height={34}
            width={80}
            className="mt-0"
            src="/images/C-Tribe_Main_Logo.svg"
            alt="c-tribe"
          />
        </div>
        <div
          className="flex cursor-pointer my-4"
          onClick={() => {
            router.push("/");
          }}
        >
          <div className="h-5 w-5 relative">
            <Image
              src={"/images/profileNavbar/home_back.svg"}
              fill
              alt="sideBar"
              color="inherit"
              style={{ objectFit: "contain" }}
            />
          </div>
          <div className="ml-2 text-sm leading-5">Home</div>
        </div>

        <div className="text-sm leading-5">Partner Portal</div>
        {partnerPortalMenu.map((item, index) => {
          const IconComponent = item.IconComponent;
          const isSelected = pathname === item.href;
          const iconColor = isSelected ? "#333E48" : "#909090";
          return (
            <div
              key={index}
              className="flex cursor-pointer mt-7"
              onClick={() => {
                router.push(item.href ?? "");
              }}
            >
              <div className="h-5 w-5 relative">
                {IconComponent && (
                  <IconComponent width={20} height={20} style={{ color: iconColor }} />
                )}
              </div>
              <div
                className={`ml-2 text-sm leading-5 ${!item.href || !pathname.includes(item.href)
                  ? "text-custom-gray2"
                  : "text-custom-gray"
                  }`}
              >
                {item.name}
              </div>
            </div>

          )

        })}
      </div>
    </>
  );
}
